var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpensly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 131,
    viewBox: "0 0 522 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.396 35.5122L163.461 59.4451L177.526 35.5122H187.921L168.964 64.7805L187.921 94.0488H177.526L163.461 71.3354L149.396 94.0488H139L157.651 64.7805L139 35.5122H149.396Z",
    fill: "#1D1B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.792 116V35.5122H209.506V44.811H210.576C211.239 43.7947 212.156 42.499 213.328 40.9238C214.526 39.3232 216.233 37.9004 218.45 36.6555C220.692 35.3852 223.724 34.75 227.546 34.75C232.489 34.75 236.846 35.9822 240.617 38.4466C244.388 40.9111 247.331 44.4045 249.446 48.9268C251.561 53.4492 252.618 58.7845 252.618 64.9329C252.618 71.1321 251.561 76.5056 249.446 81.0534C247.331 85.5757 244.401 89.0818 240.655 91.5716C236.91 94.0361 232.591 95.2683 227.699 95.2683C223.928 95.2683 220.908 94.6458 218.641 93.4009C216.373 92.1306 214.628 90.6951 213.405 89.0945C212.182 87.4685 211.239 86.122 210.576 85.0549H209.812V116H200.792ZM209.659 64.7805C209.659 69.2012 210.309 73.1011 211.608 76.4802C212.908 79.8338 214.806 82.4634 217.303 84.3689C219.8 86.249 222.858 87.189 226.476 87.189C230.247 87.189 233.394 86.1982 235.916 84.2165C238.464 82.2094 240.375 79.5163 241.649 76.1372C242.949 72.7327 243.598 68.9472 243.598 64.7805C243.598 60.6646 242.961 56.9553 241.687 53.6524C240.439 50.3242 238.541 47.6946 235.993 45.7637C233.47 43.8074 230.298 42.8293 226.476 42.8293C222.807 42.8293 219.724 43.7566 217.227 45.6113C214.73 47.4405 212.844 50.0066 211.57 53.3095C210.296 56.5869 209.659 60.4106 209.659 64.7805Z",
    fill: "#1D1B63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.991 95.2683C285.334 95.2683 280.455 94.0234 276.353 91.5335C272.276 89.0183 269.129 85.5122 266.912 81.0152C264.721 76.4929 263.626 71.2337 263.626 65.2378C263.626 59.2419 264.721 53.9573 266.912 49.3841C269.129 44.7856 272.212 41.2033 276.162 38.6372C280.137 36.0457 284.774 34.75 290.074 34.75C293.131 34.75 296.151 35.2581 299.132 36.2744C302.113 37.2906 304.827 38.9421 307.273 41.2287C309.719 43.4898 311.668 46.4878 313.12 50.2226C314.573 53.9573 315.299 58.5559 315.299 64.0183V67.8293H270.046V60.0549H306.126C306.126 56.752 305.464 53.8049 304.139 51.2134C302.839 48.6219 300.979 46.5767 298.559 45.0777C296.163 43.5788 293.335 42.8293 290.074 42.8293C286.481 42.8293 283.372 43.7185 280.748 45.4969C278.149 47.25 276.149 49.5366 274.748 52.3567C273.346 55.1768 272.645 58.2002 272.645 61.4268V66.6098C272.645 71.0305 273.41 74.778 274.939 77.8521C276.493 80.9009 278.646 83.2256 281.398 84.8262C284.15 86.4014 287.347 87.189 290.991 87.189C293.361 87.189 295.501 86.8587 297.412 86.1982C299.348 85.5122 301.017 84.4959 302.419 83.1494C303.82 81.7774 304.903 80.0752 305.667 78.0427L314.382 80.4817C313.464 83.4289 311.923 86.0203 309.757 88.2561C307.591 90.4665 304.916 92.1941 301.731 93.439C298.546 94.6585 294.966 95.2683 290.991 95.2683Z",
    fill: "#1D1B63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.04 58.8354V94.0488H329.02V35.5122H337.734V44.6585H338.498C339.874 41.686 341.964 39.2978 344.766 37.4939C347.569 35.6646 351.187 34.75 355.621 34.75C359.596 34.75 363.074 35.563 366.055 37.189C369.036 38.7896 371.355 41.2287 373.011 44.5061C374.667 47.7581 375.495 51.874 375.495 56.8537V94.0488H366.475V57.4634C366.475 52.8648 365.278 49.2825 362.883 46.7165C360.488 44.125 357.201 42.8293 353.022 42.8293C350.143 42.8293 347.569 43.4517 345.301 44.6966C343.059 45.9416 341.288 47.7581 339.989 50.1463C338.689 52.5345 338.04 55.4309 338.04 58.8354Z",
    fill: "#1D1B63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M433.561 48.622L425.458 50.9085C424.949 49.562 424.197 48.2536 423.203 46.9832C422.235 45.6875 420.91 44.6204 419.228 43.782C417.547 42.9436 415.394 42.5244 412.769 42.5244C409.176 42.5244 406.183 43.3501 403.787 45.0015C401.418 46.6275 400.233 48.6982 400.233 51.2134C400.233 53.4492 401.048 55.2149 402.679 56.5107C404.31 57.8064 406.858 58.8862 410.323 59.75L419.037 61.8841C424.286 63.1545 428.197 65.0981 430.771 67.7149C433.344 70.3064 434.631 73.6474 434.631 77.7378C434.631 81.0915 433.663 84.0894 431.726 86.7317C429.815 89.374 427.14 91.4573 423.7 92.9817C420.26 94.5061 416.26 95.2683 411.699 95.2683C405.711 95.2683 400.755 93.9726 396.831 91.3811C392.908 88.7896 390.423 85.0041 389.379 80.0244L397.94 77.8902C398.755 81.0406 400.297 83.4035 402.564 84.9787C404.858 86.5539 407.852 87.3415 411.546 87.3415C415.75 87.3415 419.088 86.4522 421.56 84.6738C424.057 82.8699 425.305 80.7104 425.305 78.1951C425.305 76.1626 424.592 74.4604 423.165 73.0884C421.738 71.6911 419.547 70.6494 416.591 69.9634L406.807 67.6768C401.431 66.4065 397.481 64.4375 394.959 61.7698C392.462 59.0767 391.213 55.7104 391.213 51.6707C391.213 48.3679 392.143 45.4461 394.003 42.9055C395.889 40.3648 398.449 38.3704 401.685 36.9223C404.947 35.4741 408.641 34.75 412.769 34.75C418.579 34.75 423.139 36.0203 426.452 38.561C429.79 41.1016 432.159 44.4553 433.561 48.622Z",
    fill: "#1D1B63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M457.228 16V94.0488H448.209V16H457.228Z",
    fill: "#1D1B63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M479.558 116C478.03 116 476.666 115.873 475.469 115.619C474.271 115.39 473.443 115.162 472.985 114.933L475.278 107.006C477.469 107.565 479.405 107.768 481.087 107.616C482.769 107.463 484.259 106.714 485.559 105.367C486.884 104.046 488.094 101.899 489.19 98.9268L490.871 94.3537L469.163 35.5122H478.947L495.152 82.1585H495.764L511.969 35.5122H521.753L496.834 102.585C495.713 105.609 494.324 108.111 492.668 110.093C491.012 112.1 489.088 113.586 486.897 114.552C484.731 115.517 482.285 116 479.558 116Z",
    fill: "#1D1B63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_441_47000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.3438,
    y: 7.34375,
    width: 109.312,
    height: 109.312,
    rx: 27.1562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3438,
    y: 7.34375,
    width: 109.312,
    height: 109.312,
    rx: 27.1562,
    fill: "url(#paint0_linear_441_47000)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8455,
    y1: 92.4615,
    x2: 87.1532,
    y2: 92.4615,
    stroke: "#1D1B63",
    strokeWidth: 8.46154
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8455,
    y1: 62,
    x2: 87.1532,
    y2: 62,
    stroke: "#1D1B63",
    strokeWidth: 8.46154
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8455,
    y1: 32.3845,
    x2: 87.1532,
    y2: 32.3845,
    stroke: "#1D1B63",
    strokeWidth: 8.46154
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8455,
    y1: 92.4185,
    x2: 87.1532,
    y2: 92.4185,
    stroke: "#1D1B63",
    strokeWidth: 8.54737
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8462,
    y1: 61.7737,
    x2: 87.1539,
    y2: 61.7737,
    stroke: "#1D1B63",
    strokeWidth: 8.54737
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.5825,
    y1: 32.4276,
    x2: 45.2748,
    y2: 32.4276,
    stroke: "#1D1B63",
    strokeWidth: 8.54737
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3438,
    y: 7.34375,
    width: 109.312,
    height: 109.312,
    rx: 27.1562,
    stroke: "#D0D5DD",
    strokeWidth: 0.6875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_441_47000",
    x: 0.6875,
    y: 0.125,
    width: 130.625,
    height: 130.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_47000"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_441_47000",
    result: "effect2_dropShadow_441_47000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_441_47000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_47000",
    x1: 66,
    y1: 7,
    x2: 66,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpensly);
export default __webpack_public_path__ + "static/media/expensly.e35dbe5abaf7c351f89887656ed5e6cd.svg";
export { ForwardRef as ReactComponent };